/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/button-has-type */
import React from 'react';
import PropTypes from 'prop-types';

import styles from './OverlayButton.module.scss';

OverlayButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

OverlayButton.defaultProps = {
  className: '',
};

export default function OverlayButton(props) {
  return (
    <button
      { ...props }
      className={ `${styles.OverlayButton} ${props.className || ''}` }
    >
      {props.children}
    </button>
  );
}
